// extracted by mini-css-extract-plugin
module.exports = {"form__group":"BaseSpecifications_form__group__RQ0Zl","group__title":"BaseSpecifications_group__title__2pZEt"};